import * as actionTypes from "../actions/actionTypes";

const INITIAL_STATE = {
  docDetails: []
};

const DocumentDetailReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.DOCUMENT_DETAIL_SUCCESS:
      return { ...state, docDetails: action.payload };
    default:
      return state;
  }
};

export default DocumentDetailReducer;
